import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { getSrcSet, imageSizes } from '@atc/images';
import { useFeatures } from '@atc/features';
import Image from '../Image/index.js';
function getIntrinsicSize(sizes) {
  // Return the size with the largest width
  return sizes?.reduce((acc, size) => {
    const curr = typeof size === 'string' ? imageSizes[size] : size;
    if (!curr) {
      return acc;
    }
    if (!acc) {
      return curr;
    }
    return curr?.width < acc?.width ? acc : curr;
  }, null);
}

/**
 *  Describe the component
 *
 */
function ResponsiveImage(_ref) {
  let {
    className,
    src,
    xsSize,
    smSize,
    mdSize,
    lgSize,
    ...rest
  } = _ref;
  const {
    image_optimization: [enableImageOptimization]
  } = useFeatures(['image_optimization']);
  const sizeSet = [xsSize, smSize, mdSize, lgSize];
  const srcSet = getSrcSet(src, sizeSet, {
    isOptimized: enableImageOptimization
  });
  const intrinsicSize = getIntrinsicSize(sizeSet);
  return /*#__PURE__*/React.createElement(Image, Object.assign({
    "data-cmp": "responsiveImage"
    // width, height is required for avoid CLS issues
    // this can override by style or the rest props
    ,
    width: intrinsicSize?.width,
    height: intrinsicSize?.height
  }, rest, {
    className: clsx('img-responsive', className),
    srcSet: srcSet,
    src: src,
    isResponsive: true
  }));
}
export default ResponsiveImage;